import type { CSSProperties } from 'react';

import { Button } from '@moniebook-web/components/atoms/button';
import { Body, BodyLarge } from '@moniebook-web/components/atoms/typography';
import { ArrowRightLine } from '@moniebook-web/icons-v2/arrows/arrow-right-line';
import { GhostFill } from '@moniebook-web/icons-v2/user-faces/ghost-fill';
import { useUserInfo } from '@moniebook-web/utils';

import { formatGhostSessionCountdown } from '../utils';
import { EndGhostSessionModal } from './end-ghost-session-modal';
import { useEndGhostSession } from './use-end-ghost-session';
import { useGhostSessionExpiry } from './use-ghost-session-expiry';

export function GhostSessionBanner() {
    const { currentBusiness } = useUserInfo();
    const { remainingMs, percentageSpent } = useGhostSessionExpiry();
    const {
        isConfirmModalOpen,
        isEndingSession,
        openConfirmModal,
        closeConfirmModal,
        confirmEndSession,
    } = useEndGhostSession();

    return (
        <>
            <div
                role='alert'
                style={
                    {
                        '--progress': `${percentageSpent - 100}%`,
                    } as CSSProperties
                }
                className='relative flex h-60 items-center justify-between gap-16 border-new-orange-600 border-b-3 px-24 py-7 transition-transform duration-200 after:absolute after:inset-0 after:-z-1 after:translate-x-[var(--progress)] after:bg-new-orange-100'>
                <div className='flex items-center font-medium text-12 sm:text-14!'>
                    <GhostFill className='mr-2 text-new-orange-600' />
                    <span className='text-new-orange-800'>Ghost Session</span>
                    <ArrowRightLine className='mx-12 hidden text-new-orange-800 sm:inline!' />
                    <span className='hidden text-new-neutral-1000 sm:inline!'>
                        {currentBusiness?.name}
                    </span>
                </div>
                <div className='flex items-center gap-16'>
                    {remainingMs !== null && (
                        <div className='flex items-center'>
                            <Body
                                weight='medium'
                                className='hidden text-new-neutral-600 sm:mr-8! sm:inline!'>
                                Time remaining
                            </Body>
                            <BodyLarge
                                weight='bold'
                                className='text-14 text-new-orange-800 tabular-nums sm:text-base!'>
                                {formatGhostSessionCountdown(remainingMs)}
                            </BodyLarge>
                        </div>
                    )}
                    <Button
                        label='End Session'
                        size='small'
                        theme='danger'
                        onClick={openConfirmModal}
                    />
                </div>
            </div>
            <EndGhostSessionModal
                isOpen={isConfirmModalOpen}
                businessName={currentBusiness?.name}
                isEnding={isEndingSession}
                onClose={closeConfirmModal}
                onConfirm={confirmEndSession}
            />
        </>
    );
}
